import "@/App.css";
import { Toaster } from "sonner";
import { LenisProvider } from "@/components/LenisProvider";
import { Nav } from "@/components/sections/Nav";
import { Hero } from "@/components/sections/Hero";
import { Stats } from "@/components/sections/Stats";
import { Station } from "@/components/sections/Station";
import { Marquee } from "@/components/sections/Marquee";
import { Manifesto } from "@/components/sections/Manifesto";
import { Expertise } from "@/components/sections/Expertise";
import { Machinery } from "@/components/sections/Machinery";
import { Timeline } from "@/components/sections/Timeline";
import { Projects } from "@/components/sections/Projects";
import { Credentials } from "@/components/sections/Credentials";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";

function App() {
  return (
    <LenisProvider>
      <div className="App" data-testid="app-root">
        <div className="grain" />
        <Nav />
        <main>
          <Hero />
          <Stats />
          <Station />
          <Marquee />
          <Manifesto />
          <Expertise />
          <Machinery />
          <Timeline />
          <Projects />
          <Credentials />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: "#1b2229", color: "#f0f4f8", border: "1px solid #3a454f", borderRadius: 0, fontFamily: "IBM Plex Mono" },
          }}
        />
      </div>
    </LenisProvider>
  );
}

export default App;
